import Stack from '@mui/material/Stack'
import LoadingSpinner from './LoadingSpinner'

export default function LoadingScreen() {
  return (
    <Stack
      sx={{
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LoadingSpinner />
    </Stack>
  )
}